import { Reveal } from "@/components/bits";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "¿Necesito tener formación previa en literatura?",
    a: "No. Sólo necesitás ganas de leer en profundidad. El programa está pensado para lectoras curiosas, no para académicas: las herramientas de análisis se van construyendo juntas, sin jerga innecesaria.",
  },
  {
    q: "¿Cómo es la dinámica del programa?",
    a: "Es completamente en vivo y virtual: nos encontramos por Zoom en una tertulia semanal, todos los lunes de 19 a 20 hs (hora Argentina), para leer y discutir juntas. Además recibís material (libros, guías) para acompañar cada lectura durante la semana.",
  },
  {
    q: "¿Qué pasa si no puedo asistir a una tertulia?",
    a: "Avisame con tiempo y te comparto el material y los puntos clave de la discusión, así llegás al siguiente encuentro al día. El material queda en tu poder para siempre.",
  },
  {
    q: "¿Hay material incluido?",
    a: "Sí. Por cada autora recibís el libro completo en PDF, una selección de textos curada y una guía de lectura con ejes de análisis. El contexto y la disección crítica se trabajan en vivo, en la tertulia de cada lunes.",
  },
  {
    q: "¿Cuántas lectoras somos por cohorte?",
    a: "Máximo doce. La cohorte es íntima a propósito: conversaciones profundas, escucha verdadera y atención personalizada para cada una.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-ink py-20 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1fr_1.5fr] lg:gap-20">
          <Reveal>
            <p className="flex items-center gap-4 text-[11px] font-medium uppercase tracking-[0.3em] text-gold">
              <span className="h-px w-10 bg-gold/60" /> Preguntas frecuentes
            </p>
            <h2 className="mt-8 font-serif text-3xl leading-[1.12] tracking-tight text-cream sm:text-4xl lg:text-5xl">
              Antes de
              <br />
              <span className="font-semibold not-italic text-gold">decidir.</span>
            </h2>
          </Reveal>

          <Reveal delay={0.15}>
            <Accordion type="single" collapsible data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-cream/10">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="py-6 text-left font-serif text-lg text-cream transition-colors hover:text-gold hover:no-underline sm:text-xl"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="text-sm font-light leading-relaxed text-ash sm:text-base"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
